import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import styles from './blogPostList.module.scss';
import BlogPostPreviewCard from '../blogPostPreviewCard/blogPostPreviewCard';
import LcResourcesArticleItem from '../lcResourcesArticleItem/lcResourcesArticleItem';

export default function BlogPostList({
  items = [],
  title = '',
  highlightedPosition = 'left',
  seeAllLink = '',
  showListThumbnail = false,
}) {
  const [highlightedItem, setHighlightedItem] = useState(null);
  const [listItems, setListItems] = useState([]);

  useEffect(() => {
    setHighlightedItem(
      highlightedPosition === 'left' ? items[0] : items[items.length - 1]
    );
    setListItems(
      highlightedPosition === 'left'
        ? items.slice(1, items.length)
        : items.slice(0, items.length - 1)
    );
  }, [highlightedPosition, items]);

  const listSection = (
    <Grid item xs={12} sm={6} className={styles.content}>
      {listItems.length > 0 &&
        listItems.map((item, index) => {
          const key = `item-${index}`;
          return (
            <div className={styles.articleContainer} key={key}>
              <LcResourcesArticleItem
                {...item}
                image={showListThumbnail ? item.image : null}
              />
            </div>
          );
        })}
    </Grid>
  );
  const cardSection = (cardPosition) =>
    highlightedItem ? (
      <Grid item xs={12} sm={6} className={styles.content}>
        <BlogPostPreviewCard
          post={{
            excerpt: highlightedItem.description,
            title: highlightedItem.subTitle.label,
            url: highlightedItem.subTitle.link,
            thumbnail: highlightedItem.image,
            product: highlightedItem.category,
            date: highlightedItem.publishedDate,
            postContent: highlightedItem.postContent,
          }}
          mode={3}
          previewCardClassName={cardPosition}
        />
      </Grid>
    ) : null;
  return (
    <div className={styles.resourceCard}>
      <div className={styles.titleSection}>
        <div className={styles.title}>
          <h2>{title}</h2>
        </div>
      </div>
      <Grid container className={styles.resContent}>
        {highlightedPosition === 'left' ? cardSection('leftCard') : listSection}
        {highlightedPosition === 'left'
          ? listSection
          : cardSection('rightCard')}
      </Grid>
      {seeAllLink && (
        <div className={styles.seeAllSection}>
          <Link
            href={seeAllLink}
            key={seeAllLink}
            className={styles.seeAllLink}
          >
            <span className={styles.seeAllText}>See All</span>
          </Link>
        </div>
      )}
    </div>
  );
}

BlogPostList.propTypes = {
  title: PropTypes.string,
  highlightedPosition: PropTypes.string,
  seeAllLink: PropTypes.string,
  items: PropTypes.array,
  showListThumbnail: PropTypes.bool,
};
